import React from "react";
import styles from "../styles.module.css";
import Delete from "../../../icons/delete";
import { useState, useEffect } from "react";
import { Select, Option } from "../../../select";
import DefaultParam from "./defaultParam";
import Body from "./body";

export default function Call({
  call,
  deleteCall,
  updateCall,
  index,
  testCall,
}) {
  const [type, setType] = useState("");
  const [url, setUrl] = useState("");
  const [name, setName] = useState("");
  const [body, setBody] = useState("");
  const [params, setParams] = useState([]);
  const [bodyParams, setBodyParams] = useState([]);
  const [headers, setHeaders] = useState([]);

  useEffect(() => {
    setType(call.type);
    setUrl(call.url);
    setName(call.name);
    setBody(call.body);
    setParams(call.params);
    setHeaders(call.headers);
    setBodyParams(call.bodyParams ? call.bodyParams : []);
  }, []);

  const handleUrlChange = () => {
    const matches = [...url.matchAll(/\[(.*?)\]/g)].map((p) => {
      return {
        name: p[1],
        index: p.index,
      };
    });

    const _params = [];
    matches.forEach((m, index) => {
      const found = params.find(
        (x) => x.name === m.name || x.index === m.index
      );
      if (!found) {
        _params.push({ ...m, default: "" });
      }
      if (found) {
        _params[index] = { ...m, default: found.default };
      }
    });

    setParams(_params);
    const newheader = {
      type,
      url,
      name,
      body,
      params: _params,
      headers,
      id: call.id,
    };
    updateCall(newheader, index);
  };

  const handleUpdate = (e) => {
    const newheader = {
      type,
      url,
      name,
      body,
      params,
      headers,
      bodyParams,
      id: call.id,
      schema: call.schema ? call.schema : null,
    };
    updateCall(newheader, index);
  };

  const handleUpdateParam = (param, index) => {
    const _params = [...params];
    _params[index] = param;
    setParams(_params);
  };
  const handleUpdateBodyParam = (param, index) => {
    const _params = [...bodyParams];
    _params[index] = param;
    setBodyParams(_params);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    deleteCall(index);
  };

  const handleBodyChange = () => {
    const matches = [...body.matchAll(/\<(.*?)\>/g)].map((p) => {
      return {
        name: p[1],
        index: p.index,
      };
    });

    const _params = [];
    matches.forEach((m, index) => {
      const found = bodyParams.find(
        (x) => x.name === m.name || x.index === m.index
      );
      if (!found) {
        _params.push({ ...m, default: "" });
      }
      if (found) {
        _params[index] = { ...m, default: found.default };
      }
    });
    console.log(_params);

    setBodyParams(_params);
    const newheader = {
      type,
      url,
      name,
      body,
      params,
      bodyParams: _params,
      headers,
      id: call.id,
    };
    updateCall(newheader, index);
  };
  return (
    <div className={styles.section}>
      <div style={{ width: "100%", display: "flex" }}>
        <div style={{ flexGrow: 2 }}>
          <div className={styles.headerTitle}>Name</div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              onBlur={handleUpdate}
              value={name}
              onChange={(e) => setName(e.target.value)}
              className={styles.callInput}
            />
            <Delete onClick={handleDelete} className={styles.deleteIcon} />
          </div>
        </div>
      </div>
      <div style={{ display: "flex", marginTop: 12 }}>
        <div style={{ marginRight: 8, width: 100 }}>
          <div className={styles.headerTitle}>Type</div>
          <Select className={styles.callInput} value={type} onChange={setType}>
            <Option value={"get"}>Get</Option>
            <Option value={"post"}>Post</Option>
            <Option value={"put"}>Put</Option>
            <Option value={"patch"}>Patch</Option>
            <Option value={"delete"}>Delete</Option>
          </Select>
        </div>
        <div style={{ flexGrow: 2 }}>
          <div className={styles.headerTitle}>
            Url - wrap dyanmic variable with [[ ]]
          </div>
          <input
            className={styles.callInput}
            value={url}
            onBlur={handleUrlChange}
            onChange={(e) => setUrl(e.target.value)}
          />
        </div>
      </div>
      {call.params.length > 0 && (
        <div style={{ marginTop: 12 }}>
          <div className={styles.headerTitle}>Dynamic Params</div>
          {call.params.map((p, index) => {
            return (
              <DefaultParam
                onChange={(p) => handleUpdateParam(p, index)}
                param={p}
                key={p.index}
              />
            );
          })}
        </div>
      )}
      {type !== "get" && type !== "" && (
        <div style={{ marginTop: 12 }}>
          <div className={styles.headerTitle}>Body</div>
          <Body onBlur={handleBodyChange} value={body} onChange={setBody} />
        </div>
      )}
      {bodyParams.length > 0 && (
        <div style={{ marginTop: 12 }}>
          <div className={styles.headerTitle}>Dynamic Params</div>
          {bodyParams.map((p, index) => {
            return (
              <DefaultParam
                onChange={(p) => handleUpdateBodyParam(p, index)}
                param={p}
                key={p.index}
              />
            );
          })}
        </div>
      )}
      {call.schema && (
        <div className={styles.verified}>This Call is Good to Go</div>
      )}
      <div onClick={() => testCall(call)} className={styles.iconButton}>
        {!call.schema ? "verify" : "Re-Test"}
      </div>
    </div>
  );
}
